import React from 'react';

export default function ErrorPage() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>!</div>
        <h2 style={styles.title}>Verbinden lukte niet</h2>
        <p style={styles.text}>
          We kunnen de server niet bereiken. Dit kan komen door onderhoud of een tijdelijke storing.
        </p>
        <button onClick={() => window.location.reload()} style={styles.button}>
          Opnieuw proberen
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--color-background-page, #eef1f5)',
    padding: '2rem',
  },
  card: {
    textAlign: 'center',
    maxWidth: 480,
  },
  icon: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: '#dc3545',
    color: '#fff',
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: '64px',
    margin: '0 auto 1rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: 'var(--color-text-primary, #231f20)',
    margin: '0.5rem 0',
  },
  text: {
    fontSize: '1rem',
    color: 'var(--color-dark-grey, #58595b)',
    marginBottom: '1.5rem',
  },
  button: {
    padding: '0.75rem 1.5rem',
    backgroundColor: 'var(--color-yellow, #ffdd00)',
    color: 'var(--color-text-primary, #231f20)',
    fontWeight: 700,
    borderRadius: 8,
    border: 'none',
    cursor: 'pointer',
    fontSize: '1rem',
  },
};
